import React from 'react'
import { FlexRow } from 'components/common/Containers'
import { Select } from 'components/common/Select'

const limitOptions = [
  {
    label: '5',
    value: '5',
  },
  {
    label: '10',
    value: '10',
  },
  {
    label: '15',
    value: '15',
  },
  {
    label: '20',
    value: '20',
  },
  {
    label: '25',
    value: '25',
  },
  {
    label: '50',
    value: '50',
  },
  {
    label: '100',
    value: '100',
  },
  {
    label: '200',
    value: '200',
  },
]

interface Props {
  value: number
  onChange: (value: number) => void
}

const LimitFilter: React.FC<Props> = ({ value, onChange }) => {
  return (
    <FlexRow gap="25px" align="center">
      Limit
      <Select
        value={value}
        options={limitOptions}
        onChange={(e) => onChange(parseInt(e.target.value))}
      />
    </FlexRow>
  )
}

export default LimitFilter
